/*TODO CM: Clean up. I combined emp-timeoff.component.html into this.*/

import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { TimeOffRequestBus } from '../../shared/models/TimeOffRequestBus';
import { EmployeeService } from '../../shared/services/employee.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { RequestTimeOffReference } from '../../shared/models/RequestTimeOffReference';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SchedulerEvent, SlotClickEvent } from '@progress/kendo-angular-scheduler';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { CommonValues } from '../../shared/static/CommonValues';

@Component({
    selector: 'emp-timeoff',
    templateUrl: './emp-timeoff.component.html',
    styleUrls: ['./emp-timeoff.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EmpTimeoffComponent implements OnInit, OnDestroy {

  constructor(private svc_data: EmployeeService, private globals: GlobalsService) {

  }

  dataGrid: TimeOffRequestBus[];
  dataRef: RequestTimeOffReference;
  subs_data: Subscription;
  subs_data_ref: Subscription;
  get personId(): any {
    return CommonFunctions.hasValue(this.globals) ? this.globals.personId : null;
  }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
  public editDataItem: TimeOffRequestBus;
  public isNew: boolean;
  dataLoading: boolean = false;

  ngOnInit() {
    //      this.personId = this.globals.personId;
    this.subs_data_ref = this.svc_data.getRequestTimeOffReferenceData(this.globals.userId).subscribe(data => {
      this.dataRef = data;
    });
    this.getTimeOff();
  }
  ngOnDestroy(): void {
    CommonFunctions.unsubscribe(this.subs_data);
  }

  getTimeOff(): void {
    this.dataLoading = true;
    this.subs_data = this.svc_data.getTimeoffRequests(this.personId).subscribe(data => {
      this.dataGrid = data;
      this.dataLoading = false;
    });
  }
  public rowCallback = (context: RowClassArgs) => {
    switch (context.dataItem.timeOffStatus.status) {
      case 'Rejected':
        return { red: true };
      case 'Approved':
        return { green: true };
      default:
        return {};
    }
  };

  public addHandler() {
    this.editDataItem = new TimeOffRequestBus();
    this.editDataItem.companyId = this.globals.companyId;
    this.editDataItem.insertedByUserId = this.globals.userId;
    this.editDataItem.requestedPersonId = this.globals.personId;
    this.editDataItem.statusId = 1;
    //this.editDataItem.
    this.isNew = true;
  }

  public editHandler({ dataItem }) {
    this.editDataItem = new TimeOffRequestBus(dataItem);
    this.editDataItem.setForEdit();
    this.isNew = false;
  }

  public cancelHandler() {
    this.editDataItem = undefined;
  }

  public saveHandler(model: TimeOffRequestBus) {
    this.saving = true;
    let data: TimeOffRequestBus = new TimeOffRequestBus(model);
    data.companyId = this.globals.companyId;
    data.insertedByUserId = this.globals.userId;
    data.requestedPersonId = this.globals.personId;
    data.statusId = 1;
    data.notes = CommonFunctions.getStringValueIfNull(data.notes);
    data.rejectAcceptMsg = CommonFunctions.getStringValueIfNull(data.rejectAcceptMsg);
    data.nonPaid = CommonFunctions.getBoolValueIfNull(data.nonPaid);
    data.setForSave();
    data.setBeforeSave();
    if (data.timeOffTypeId.toLowerCase() == CommonValues.TimeOffType_JURY || data.timeOffTypeId.toLowerCase() == CommonValues.TimeOffType_OTH) {
      data.nonPaid = true;

    }
    //this.editService.save(model, this.isNew);
    this.svc_data.saveTimeoffRequest(data).subscribe(d => {
      this.saveSuccess();
      this.getTimeOff();
      this.saving = false;
      this.clearInputs();

    });
    this.editDataItem = undefined;
  }

  public removeHandler({ dataItem }) {
    //this.editService.remove(dataItem);
  }
  public active = false;
  public editForm: UntypedFormGroup = new UntypedFormGroup({
    'timeOffRequestId': new UntypedFormControl(),
    'companyId': new UntypedFormControl(),
    'requestedPersonId': new UntypedFormControl(this.personId),
    'dateRequested': new UntypedFormControl(DateFunctions.getDateNow(), Validators.required),
    'hours': new UntypedFormControl(0, Validators.required),
    'mins': new UntypedFormControl(0),
    'statusId': new UntypedFormControl(null),
    'insertDt': new UntypedFormControl(),
    'insertedByUserId': new UntypedFormControl(),
    'notes': new UntypedFormControl(''),
    'timeOffTypeId': new UntypedFormControl(null, Validators.required),
    'nonPaid': new UntypedFormControl(false),
    'rejectAcceptMsg': new UntypedFormControl(),

  });
  @Input() public data_ref: RequestTimeOffReference;
  @Input() public set model(model: TimeOffRequestBus) {
    this.editForm.reset(model);
    this.active = model !== undefined;
  }

  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<TimeOffRequestBus> = new EventEmitter();

  readOnly: boolean = false;
  data: TimeOffRequestBus;
  selectedDate: Date = DateFunctions.getDateNow();
  events: SchedulerEvent[] = [];
  selectedHrs: number = 0;
  selectedMins: number = 0;
  selectedTypes: string = "";
  saving: boolean = false;
  notes: string = "";
  nonPaid: boolean = false;

  public defaultItem: { description: string, value: number; } = { description: "Select Time Type...", value: null };
  public onSave(e): void {

    this.saveHandler(this.editForm.value);

    this.active = false;
  }

  public onCancel(e): void {
    this.clearInputs();

  }
  private clearInputs(): void {
    let dataObj: TimeOffRequestBus = new TimeOffRequestBus();
    dataObj.companyId = this.globals.companyId;
    dataObj.insertedByUserId = this.globals.userId;
    dataObj.requestedPersonId = this.globals.personId;
    dataObj.statusId = 1;
    dataObj.dateRequested = DateFunctions.getDateNow();
    dataObj.timeOffTypeId = null;
    dataObj.hours = 0;
    dataObj.mins = 0;
    dataObj.notes = "";
    this.editForm.reset(dataObj);
    this.editForm.markAsDirty();
    this.selectedDate = DateFunctions.getDateNow();
    //        this.editForm.controls["timeOffTypeId"].setValue(null);
    this.selectedHrs = 0;
    this.selectedMins = 0;
    this.notes = "";
    this.nonPaid = false;

  }

  private closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }
  dateChanged(e: any) {
  }
  eventClick(e: any) {
  }
  slotClick(e: SlotClickEvent) {
    this.selectedDate = e.start;
    //this.editForm.value.dateRequested = this.selectedDate;
    this.editForm.controls["dateRequested"].setValue(this.selectedDate);
  }

  protected saveSuccess(message: string = null) {
    let not: string = "Timeoff Request was Successfully Saved";
    this.globals.notifySuccess(not);
  }
  protected saveError() {
    let not: string = "There was a problem saving the Timeoff Request";
    this.globals.notifyError(not, true);
  }
  hasHours() {
    if (this.editForm) {
      if (this.editForm.value.mins && this.editForm.value.mins > 0) { return true; }
      if (this.editForm.value.hours && this.editForm.value.hours > 0) { return true; }
    }

    return false;
  }
}
